// src/components/GlobalUploadQueue.jsx
import React from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import UploadQueueModal from './upload/UploadQueueModal';

const GlobalUploadQueue = () => {
  const location = useLocation();

  // Define the exact routes where upload queue should be shown
  const allowedRoutes = [
    '/dashboard',
    '/my-files',
    '/my-passwords', 
    '/my-banking',
    '/my-blockchain',
    '/endowment-centre',
    '/profile',
    '/checkout-success',
    '/contact',
    '/faq'
  ];

  // Check if current route matches any of the allowed routes
  const shouldShowUploadQueue = allowedRoutes.some(route => 
    location.pathname === route || location.pathname.startsWith(route + '/')
  );

  // Don't render anything if not on allowed routes
  if (!shouldShowUploadQueue) {
    return null;
  }

  return createPortal(
    <UploadQueueModal />,
    document.body
  );
};

export default GlobalUploadQueue;